/** @jsxImportSource @emotion/react */
import { FeatureFlagGate } from '@app/FeatureFlag/FeatureFlagGate'
import { FEATURE_FLAGS } from '@app/app-constants'
import AppLoaderRefactored from '@app/routes/App/AppLoaderRefactored'
import { Box } from '@mui/material'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { appContentContainer } from './BaseLayout.style'
import { ModalManager } from './ModalManager'
import Sidebar from './Sidebar/Sidebar'

const BaseLayout = () => {
  return (
    <div>
      <div className="relative flex h-svh w-full overflow-hidden">
        <Sidebar />
        <Box css={appContentContainer}>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Box>
      </div>

      <Suspense fallback={null}>
        <ModalManager />
      </Suspense>

      <FeatureFlagGate flag={FEATURE_FLAGS.RISK_MODULE}>
        <AppLoaderRefactored />
      </FeatureFlagGate>
    </div>
  )
}

export default BaseLayout
